<template>
  <div>评论管理</div>
</template>

<script>
export default {

}
</script>

<style>

</style>